export function getModuleFromTenant(tenant: string): string {
  return tenant.split("_")[0];
}

export function hasAbility(abilities: string[], module: string, suffix: string): boolean {
  return abilities.some((ability) => ability.includes(module + suffix));
}

export function pruneRxLiteMenu(
  menu: string[],
  abilities: string[],
  module: string,
): {
  menu: string[];
  showClaims: boolean;
  showMember: boolean;
} {
  const showClaims = hasAbility(abilities, module, ".rxlite.claims");
  const showMember = hasAbility(abilities, module, ".rxlite.member");

  const nextMenu = menu.filter((item) => {
    if (item === "Claims Search") {
      return showClaims;
    }
    if (item === "Member Search") {
      return showMember;
    }
    return true;
  });

  return {
    menu: nextMenu,
    showClaims,
    showMember,
  };
}
